import { combineReducers } from "redux";
import commonReducer from "../../../../Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketsParams";
import HighestOI from "./highestOI";
export default combineReducers({
    reducersData: HighestOI,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
